import React, { Children } from 'react';
import GalleryView, { GalleryItem } from '../../components/Creative/GalleryView';
// Sample data for character art
const characterArtItems: GalleryItem[] = [{
  id: '1',
  imageUrl: 'https://images.unsplash.com/photo-1580927752452-89d86da3fa0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Fantasy Hero Portrait',
  creator: 'Alex Chen',
  price: 150,
  priceType: 'fixed',
  serviceType: 'Character Portrait',
  genre: ['Fantasy', 'Epic'],
  description: 'Detailed portrait of your fantasy hero with weapons and distinctive features.'
}, {
  id: '2',
  imageUrl: 'https://images.unsplash.com/photo-1613336026275-d6d473084e85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Urban Fantasy Character',
  creator: 'Mia Johnson',
  price: 200,
  priceType: 'starting',
  serviceType: 'Full Body Illustration',
  genre: ['Urban Fantasy', 'Paranormal'],
  description: 'Modern character with supernatural elements in an urban setting.'
}, {
  id: '3',
  imageUrl: 'https://images.unsplash.com/photo-1580927752452-89d86da3fa0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Sci-Fi Protagonist',
  creator: 'David Park',
  price: 180,
  priceType: 'fixed',
  serviceType: 'Character Portrait',
  genre: ['Science Fiction', 'Cyberpunk'],
  description: 'Futuristic character design with tech elements and cyberpunk aesthetic.'
}, {
  id: '4',
  imageUrl: 'https://images.unsplash.com/photo-1613336026275-d6d473084e85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Character Group Shot',
  creator: 'Alex Chen',
  price: 350,
  priceType: 'commissioned',
  serviceType: 'Group Illustration',
  genre: ['Fantasy', 'Adventure'],
  description: 'Commissioned artwork featuring multiple characters from a fantasy series.'
}, {
  id: '5',
  imageUrl: 'https://images.unsplash.com/photo-1580927752452-89d86da3fa0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Romance Novel Couple',
  creator: 'Mia Johnson',
  price: 225,
  priceType: 'fixed',
  serviceType: 'Couple Portrait',
  genre: ['Romance', 'Contemporary'],
  description: 'Romantic illustration of a couple for romance novel promotional materials.'
}, {
  id: '6',
  imageUrl: 'https://images.unsplash.com/photo-1613336026275-d6d473084e85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Villain Character Design',
  creator: 'David Park',
  price: 190,
  priceType: 'starting',
  serviceType: 'Character Portrait',
  genre: ['Fantasy', 'Horror'],
  description: 'Menacing villain design with attention to sinister details and atmosphere.'
}, {
  id: '7',
  imageUrl: 'https://images.unsplash.com/photo-1580927752452-89d86da3fa0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: "Children's Book Character",
  creator: 'Alex Chen',
  price: 120,
  priceType: 'fixed',
  serviceType: 'Character Design',
  genre: ["Children's", 'Middle Grade'],
  description: "Friendly, approachable character design for children's books."
}, {
  id: '8',
  imageUrl: 'https://images.unsplash.com/photo-1613336026275-d6d473084e85?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
  title: 'Historical Figure',
  creator: 'Mia Johnson',
  price: 175,
  priceType: 'starting',
  serviceType: 'Character Portrait',
  genre: ['Historical', 'Biography'],
  description: 'Period-accurate portrayal of historical figures with authentic details.'
}];
const CharacterArtGallery = () => {
  return <GalleryView items={characterArtItems} title="Character Art Gallery" categoryName="Character Designs" data-id="element-8587" data-mp="lywylyqvsuni" />;
};
export default CharacterArtGallery;